module.exports = __webpack_public_path__ + "img/jnt.8e301c26.svg";